var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"country"},[_c('img',{attrs:{"src":("https://catalog.oohdesk.ru/images/countries/" + _vm.abbreviation + ".png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }